import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import store from "@/store";

Vue.use(abilitiesPlugin, store.getters.ability)
